import { LitElement, html } from "../vendor/lit-element/lit-element";

import "./HomeostasisInitial";
import "./HomeostasisChunk";

// async function loadExtraStates() {
//   await import("./HomeostasisChunk");
// }

// loadExtraStates();

class HomeostasisChart extends LitElement {
  static get properties() {
    return {
      activeState: { type: Number },
    };
  }

  constructor() {
    super();

    this.activeState = 0;
    this.states = [
      html`<homeostasis-initial></homeostasis-initial>`,
      html`<homeostasis-pth></homeostasis-pth>`,
      html`<homeostasis-calcitriol></homeostasis-calcitriol>`,
      html`<homeostasis-fgf></homeostasis-fgf>`,
    ];
  }

  _resetState() {
    const buttons = document.querySelectorAll(".button-wrapper > button");
    const infoboxes = document.querySelectorAll(".infobox");

    buttons.forEach((button) => {
      button.classList.remove("active");
    });

    infoboxes.forEach((infobox) => {
      infobox.classList.remove("active");
    });

    document.querySelectorAll(".small-icon").forEach((icon) => {
      icon.shadowRoot.querySelectorAll(".plus, .minus").forEach((icon_node) => {
        icon_node.classList.remove("active");
      });
    });

    this.activeState = 0;
  }

  _handlePthClicked() {
    this._resetState();
    document.getElementById("button-pth").classList.add("active");
    document.getElementById("infobox-pth").classList.add("active");
    document
      .querySelector("#kidney-icon")
      .shadowRoot.querySelectorAll(".plus")
      .forEach((plus) => {
        plus.classList.add("active");
      });
    document
      .querySelector("#bone-icon")
      .shadowRoot.querySelectorAll(".plus")
      .forEach((plus) => {
        plus.classList.add("active");
      });
    this.activeState = 1;
  }

  _handleCalcClicked() {
    this._resetState();
    document.getElementById("button-calcitriol").classList.add("active");
    document.getElementById("infobox-calcitriol").classList.add("active");
    this.activeState = 2;
    document
      .querySelector("#thyroid-icon")
      .shadowRoot.querySelectorAll(".minus")
      .forEach((minus) => {
        minus.classList.add("active");
      });
    document
      .querySelector("#bone-icon")
      .shadowRoot.querySelectorAll(".plus")
      .forEach((plus) => {
        plus.classList.add("active");
      });
  }

  _handleFgfClicked() {
    this._resetState();
    document.getElementById("button-fgf23").classList.add("active");
    document.getElementById("infobox-fgf23").classList.add("active");
    document
      .querySelector("#thyroid-icon")
      .shadowRoot.querySelectorAll(".minus")
      .forEach((minus) => {
        minus.classList.add("active");
      });
    document
      .querySelector("#kidney-icon")
      .shadowRoot.querySelectorAll(".minus")
      .forEach((minus) => {
        minus.classList.add("active");
      });
    this.activeState = 3;
  }

  connectedCallback() {
    super.connectedCallback(); // call this or it won't render at all.

    const buttons = {
      pth: document.getElementById("button-pth"),
      calcitriol: document.getElementById("button-calcitriol"),
      fgf: document.getElementById("button-fgf23"),
    };

    buttons.pth.addEventListener("click", this._handlePthClicked.bind(this));
    buttons.pth.addEventListener(
      "mouseenter",
      this._handlePthClicked.bind(this)
    );
    buttons.pth.addEventListener("mouseleave", this._resetState.bind(this));
    buttons.calcitriol.addEventListener(
      "click",
      this._handleCalcClicked.bind(this)
    );
    buttons.calcitriol.addEventListener(
      "mouseenter",
      this._handleCalcClicked.bind(this)
    );
    buttons.calcitriol.addEventListener(
      "mouseleave",
      this._resetState.bind(this)
    );
    buttons.fgf.addEventListener("click", this._handleFgfClicked.bind(this));
    buttons.fgf.addEventListener(
      "mouseenter",
      this._handleFgfClicked.bind(this)
    );
    buttons.fgf.addEventListener("mouseleave", this._resetState.bind(this));
  }

  // This is needed to not append the render() result to a shadow dom (so that we can animate it.)
  createRenderRoot() {
    return this;
  }

  render() {
    return html`${this.states[this.activeState]}`;
  }
}

customElements.define("homeostasis-chart", HomeostasisChart);
